/* Auryllo referral attribution v1.1.0 */
(function () {
  'use strict';
  if (window.AurylloReferral) return;
  var key = 'auryllo_referral_v1', ttl = 30 * 86400000, attrs = {}, started = false;
  var resuming = new WeakSet();
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var fields = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term'];
  function allowed() {
    var p = window.Shopify && Shopify.customerPrivacy;
    return !!(p && p.analyticsProcessingAllowed() && p.marketingAllowed());
  }
  function clean(v) { return String(v || '').replace(/[\x00-\x1f]/g, '').slice(0, 200); }
  function read() { try { return JSON.parse(localStorage.getItem(key)); } catch (_) { return null; } }
  function save(v) { try { localStorage.setItem(key, JSON.stringify(v)); } catch (_) {} }
  function touch() {
    var q = new URLSearchParams(location.search), ref = null, t = { time: new Date().toISOString(), page: location.origin + location.pathname };
    try { ref = new URL(document.referrer); } catch (_) {}
    var external = ref && ref.hostname !== location.hostname && !/(^|\.)(auryllo\.com|myshopify\.com|shopify\.com|shop\.app)$/.test(ref.hostname);
    t.referrer = external ? ref.origin + ref.pathname : '';
    fields.forEach(function (f) { t[f] = clean(q.get(f)); });
    t.referralCode = clean(q.get('ref')).trim();
    t.source = t.referralCode || t.utm_source;
    t.medium = t.utm_medium || (t.referralCode ? 'referral' : '');
    if (!t.source && q.has('fbclid')) { t.source = 'Meta (Facebook/Instagram)'; t.medium = t.medium || 'social'; }
    if (!t.source && q.has('gclid')) { t.source = 'google'; t.medium = t.medium || 'cpc'; }
    if (!t.source && q.has('ttclid')) { t.source = 'tiktok'; t.medium = t.medium || 'social'; }
    if (!t.source && external) {
      var h = ref.hostname;
      t.source = /(^|\.)instagram\.com$/.test(h) ? 'instagram' : /(^|\.)(facebook\.com|fb\.com)$/.test(h) ? 'facebook' : /(^|\.)tiktok\.com$/.test(h) ? 'tiktok' : h;
      t.medium = t.medium || (/instagram|facebook|tiktok|pinterest/.test(t.source) ? 'social' : 'referral');
    }
    t.source = t.source || 'Direct / Unknown';
    t.medium = t.medium || 'none';
    t.attributed = !!(t.referralCode || t.utm_source || t.utm_campaign || external || q.has('fbclid') || q.has('gclid') || q.has('ttclid'));
    return t;
  }
  function build(v) {
    attrs = {};
    [['First', v.first], ['Last', v.last]].forEach(function (pair) {
      var p = pair[0] + ' ', t = pair[1];
      attrs[p + 'Referral Source'] = t.source;
      attrs[p + 'Referral Code'] = t.referralCode || '';
      attrs[p + 'Referral Medium'] = t.medium;
      attrs[p + 'Referrer'] = t.referrer || 'Not provided';
      attrs[p + 'Landing Page'] = t.page;
      attrs[p + 'Visit Time (UTC)'] = t.time;
      fields.forEach(function (f) { attrs[p + f] = t[f] || ''; });
    });
  }
  function sync() {
    if (!allowed() || !started) return Promise.resolve();
    return fetch(root + 'cart/update.js', {
      method: 'POST', credentials: 'same-origin', keepalive: true,
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ attributes: attrs })
    }).then(function (r) { if (!r.ok) throw new Error('Referral save failed'); return r.json(); })
      .catch(function () { return null; });
  }
  function forms() {
    if (!allowed() || !started) return;
    document.querySelectorAll('form[action]').forEach(function (form) {
      var path; try { path = new URL(form.action, location.href).pathname; } catch (_) { return; }
      if (!/\/cart\/?$/.test(path)) return;
      Object.keys(attrs).forEach(function (k) {
        var name = 'attributes[' + k + ']';
        var input = Array.from(form.elements).find(function (el) { return el.name === name; });
        if (!input) { input = document.createElement('input'); input.type = 'hidden'; input.name = name; input.dataset.aurylloReferral = 'true'; form.appendChild(input); }
        input.value = attrs[k];
      });
    });
  }
  function start() {
    if (!allowed()) {
      started = false; attrs = {};
      try { localStorage.removeItem(key); } catch (_) {}
      document.querySelectorAll('[data-auryllo-referral]').forEach(function (e) { e.remove(); });
      return;
    }
    if (started) return;
    var now = Date.now(), v = read(), t = touch();
    if (!v || !v.expires || v.expires < now || !v.first || !v.last) v = { first: t, last: t, expires: now + ttl };
    else if (t.attributed) v.last = t;
    save(v); build(v); started = true; forms(); sync();
  }
  window.AurylloReferral = { sync: sync, version: '1.1.0' };
  document.addEventListener('visitorConsentCollected', start);
  document.addEventListener('submit', function (e) {
    forms();
    var form = e.target;
    if (!allowed() || !started || !form.action || !/\/cart\/add\/?$/.test(new URL(form.action, location.href).pathname)) return;
    if (resuming.has(form)) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    var submitter = e.submitter;
    Promise.race([sync(), new Promise(function (resolve) { setTimeout(resolve, 1500); })]).then(function () {
      resuming.add(form);
      try { form.requestSubmit(submitter || undefined); } finally { resuming.delete(form); }
    });
  }, true);
  document.addEventListener('shopify:section:load', forms);
  window.addEventListener('pageshow', function () { start(); forms(); });
  function boot() {
    if (window.Shopify && Shopify.customerPrivacy) start();
    else if (window.Shopify && Shopify.loadFeatures) {
      Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function (error) { if (!error) start(); });
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
